import { AxiosPromise } from 'axios';

import { config } from '@mytaxi/config-store';

import { ExternalPaymentSolution } from '../types/ExternalPaymentSolution';
import { authorizedAxiosInstance } from './axios-instance';

interface CentralOrganisationListResponse {
    centralOrganisationList: CentralOrganisation[];
    pageMetadata: {
        size: number;
        totalElements: number;
        totalPages: number;
        number: number;
    };
}

export const getAvailableCentralOrganisations = (
    page: number = 1,
    searchQuery?: string,
): AxiosPromise<CentralOrganisationListResponse> => {
    const searchParams = new URLSearchParams();
    searchParams.set('page', page.toString());
    searchParams.set('size', '20');

    if (searchQuery && searchQuery.trim().length > 0) {
        searchParams.set('query', searchQuery.trim());
    }

    const url = `${config.getItem('apgsUrl')}/v1/central-organisations?${searchParams.toString()}`;
    return authorizedAxiosInstance.get(url);
};

export interface CentralOrganisation {
    id: number;
    name: string;
    enabledAttributes: string[];
}

export const getCentralOrganisationDetails = (centralOrganisationId: number): AxiosPromise<CentralOrganisation> => {
    const url = `${config.getItem('apgsUrl')}/v1/central-organisations/${centralOrganisationId}`;
    return authorizedAxiosInstance.get(url);
};

export interface BusinessAccount {
    id: number;
    name: string;
    inAppName: string;
    countryCode: string;
    hrToolsIntegrationEnabled: boolean;
    employeeListDownloadEnabled: boolean;
    externalPaymentSolution: ExternalPaymentSolution;
    legalEntityDetails: {
        id: number;
        name: string;
    };
}

export interface CentralOrganisationBusinessAccountListResponse {
    businessAccounts: BusinessAccount[];
    pageMetadata: {
        size: number;
        totalElements: number;
        totalPages: number;
        number: number;
    };
}

export const getAvailableCentralOrganisationBusinessAccounts = (
    centralOrganisationId: number,
    page: number = 1,
    searchQuery?: string,
): AxiosPromise<CentralOrganisationBusinessAccountListResponse> => {
    const searchParams = new URLSearchParams();
    searchParams.set('page', page.toString());
    searchParams.set('size', '20');

    if (searchQuery && searchQuery.trim().length > 0) {
        searchParams.set('query', searchQuery.trim());
    }

    const url = `${config.getItem('apgsUrl')}/v1/central-organisations/${centralOrganisationId}/business-accounts?${searchParams.toString()}`;
    return authorizedAxiosInstance.get(url);
};
